<template>
  <span
    class="Icon"
    :class="[
      tone ? variationName('tone', tone) : '',
      rotate ? variationName('rotate', rotate) : '',
    ]"
  >
    <p-text v-if="accessibilityLabel" as="span" visuallyHidden>
      {{ accessibilityLabel }}
    </p-text>

    <slot>
      <div :is="svg" />
    </slot>
  </span>
</template>

<script>
import { variationName } from '@/components/polaris/polarisUtils';
import PText from '@/components/polaris/PText';

export default {
  name: 'PIcon',
  components: { PText },
  props: {
    tone: {
      type: String,
      default: '',
    },
    rotate: {
      type: String,
      default: '',
    },
    accessibilityLabel: {
      type: String,
      default: '',
    },
    svg: {
      type: String,
      default: '',
    },
  },
  methods: {
    variationName,
  },
};
</script>

<style lang="scss">
//@import '../../styles/common';

.Icon {
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 20px;
  max-height: 100%;
  max-width: 100%;
  margin: auto;
}

.Icon svg {
  fill: currentColor;
}

.toneInherit svg {
  color: inherit;
}

.toneBase svg {
  color: var(--p-color-icon);
}

.toneSubdued svg {
  color: var(--p-color-icon-secondary);
}

.toneCaution svg {
  color: var(--p-color-icon-caution);
}

.toneWarning svg {
  color: var(--p-color-icon-warning);
}

.toneCritical svg {
  color: var(--p-color-icon-critical);
}

.toneInteractive svg {
  color: var(--p-color-icon-emphasis);
}

.toneInfo svg {
  color: var(--p-color-icon-info);
}

.toneSuccess svg {
  color: var(--p-color-icon-success);
}

.tonePrimary svg {
  color: var(--p-color-icon-brand);
}

.toneEmphasis svg {
  color: var(--p-color-icon-emphasis);
}

.toneMagic svg {
  color: var(--p-color-icon-magic);
}

.toneTextCaution svg {
  color: var(--p-color-text-caution);
}

.toneTextWarning svg {
  color: var(--p-color-text-warning);
}

.toneTextCritical svg {
  color: var(--p-color-text-critical);
}

.toneTextInfo svg {
  color: var(--p-color-text-info);
}

.toneTextPrimary svg {
  color: var(--p-color-text-brand);
}

.toneTextSuccess svg {
  color: var(--p-color-text-success);
}

.toneTextMagic svg {
  color: var(--p-color-text-magic);
}

.rotate90 svg {
  transform: rotate(90deg);
}

.Icon svg,
.Icon img {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}

.Placeholder {
  // stylelint-disable-next-line -- generated by polaris-migrator DO NOT COPY
  padding-bottom: 100%;
  background: var(--p-color-bg-fill-tertiary);
  border-radius: var(--p-border-radius-100);
}
</style>
